import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthModal from '../components/AuthModal';
import '../styles/LoginPage.css';

const LoginPage: React.FC = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  const handleStartReadingClick = () => {
    setIsAuthModalOpen(true);
  };

  return (
    <div className="login-container">
      <Link to="/" className="back-link">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        返回首页
      </Link>

      <div className="login-content-wrapper">
        <div className="hero-content">
          <div className="title-group">
            <h1 className="hero-title">思想</h1>
            <h2 className="hero-subtitle-main">文字与共鸣</h2>
          </div>
          <p className="hero-description">在这里，每一个想法都值得被记录，每一次思考都值得被分享</p>
          <button className="start-reading-btn" onClick={handleStartReadingClick}>
            开始阅读
          </button>
        </div>
        <div className="artwork-section">
          <div className="artwork">
            <svg width="500" height="600" viewBox="0 0 600 700" fill="none">
              {/* 大色块背景 */}
              <rect x="450" y="80" width="120" height="150" fill="#000000" opacity="0.1" />
              <rect x="480" y="230" width="80" height="100" fill="#000000" opacity="0.08" />
              <rect x="520" y="330" width="60" height="80" fill="#000000" opacity="0.06" />

              {/* 白色色块 */}
              <rect x="470" y="110" width="90" height="110" fill="#ffffff" opacity="0.15" />
              <rect x="490" y="250" width="60" height="70" fill="#ffffff" opacity="0.12" />

              {/* 背景装饰 - 多层圆形 */}
              <circle cx="500" cy="110" r="100" fill="url(#gradient1)" opacity="0.06" />
              <circle cx="520" cy="150" r="70" fill="url(#gradient2)" opacity="0.08" />
              <circle cx="480" cy="630" r="80" fill="url(#gradient3)" opacity="0.05" />
              <circle cx="540" cy="680" r="50" fill="url(#gradient4)" opacity="0.07" />

              {/* 主要图形 - 复杂的书籍和写作场景 */}
              {/* 主书籍 */}
              <rect x="350" y="150" width="140" height="180" rx="10" fill="url(#gradient5)" opacity="0.12" stroke="#000000" strokeWidth="1.5" />
              <rect x="355" y="155" width="130" height="170" rx="8" fill="url(#gradient6)" opacity="0.08" />

              {/* 书页线条 - 更多细节 */}
              <line x1="365" y1="180" x2="475" y2="180" stroke="#000000" strokeWidth="0.8" opacity="0.4" />
              <line x1="365" y1="200" x2="475" y2="200" stroke="#000000" strokeWidth="0.6" opacity="0.3" />
              <line x1="365" y1="220" x2="475" y2="220" stroke="#000000" strokeWidth="0.8" opacity="0.4" />
              <line x1="365" y1="240" x2="475" y2="240" stroke="#000000" strokeWidth="0.6" opacity="0.3" />
              <line x1="365" y1="260" x2="475" y2="260" stroke="#000000" strokeWidth="0.8" opacity="0.4" />
              <line x1="365" y1="280" x2="475" y2="280" stroke="#000000" strokeWidth="0.6" opacity="0.3" />
              <line x1="365" y1="300" x2="475" y2="300" stroke="#000000" strokeWidth="0.8" opacity="0.4" />
              <line x1="365" y1="320" x2="475" y2="320" stroke="#000000" strokeWidth="0.6" opacity="0.3" />

              {/* 第二本书 - 叠加效果 */}
              <rect x="380" y="170" width="100" height="130" rx="6" fill="url(#gradient7)" opacity="0.1" stroke="#000000" strokeWidth="1" />
              <line x1="390" y1="190" x2="470" y2="190" stroke="#000000" strokeWidth="0.5" opacity="0.3" />
              <line x1="390" y1="205" x2="470" y2="205" stroke="#000000" strokeWidth="0.5" opacity="0.2" />
              <line x1="390" y1="220" x2="470" y2="220" stroke="#000000" strokeWidth="0.5" opacity="0.3" />

              {/* 笔的复杂表现 */}
              <line x1="420" y1="110" x2="420" y2="380" stroke="#000000" strokeWidth="2.5" opacity="0.7" />
              <circle cx="420" cy="105" r="4" fill="#000000" opacity="0.8" />
              <circle cx="420" cy="385" r="3" fill="#000000" opacity="0.6" />

              {/* 第二支笔 */}
              <line x1="440" y1="130" x2="440" y2="350" stroke="#000000" strokeWidth="1.5" opacity="0.5" />
              <circle cx="440" cy="125" r="2.5" fill="#000000" opacity="0.6" />
              <circle cx="440" cy="355" r="2" fill="#000000" opacity="0.4" />

              {/* 复杂的思想泡泡系统 */}
              <circle cx="480" cy="90" r="20" fill="url(#gradient8)" opacity="0.25" stroke="#000000" strokeWidth="1.2" />
              <circle cx="510" cy="70" r="12" fill="url(#gradient8)" opacity="0.2" stroke="#000000" strokeWidth="0.8" />
              <circle cx="530" cy="55" r="8" fill="url(#gradient8)" opacity="0.15" stroke="#000000" strokeWidth="0.6" />
              <circle cx="545" cy="45" r="5" fill="url(#gradient8)" opacity="0.1" stroke="#000000" strokeWidth="0.4" />

              {/* 连接线 */}
              <line x1="480" y1="90" x2="510" y2="70" stroke="#000000" strokeWidth="0.8" opacity="0.3" />
              <line x1="510" y1="70" x2="530" y2="55" stroke="#000000" strokeWidth="0.6" opacity="0.2" />
              <line x1="530" y1="55" x2="545" y2="45" stroke="#000000" strokeWidth="0.4" opacity="0.15" />

              {/* 装饰性曲线 - 更复杂 */}
              <path d="M320 430 Q450 410 580 430 T840 430" stroke="#000000" strokeWidth="1.2" fill="none" opacity="0.3" />
              <path d="M300 460 Q450 440 600 460 T900 460" stroke="#000000" strokeWidth="1" fill="none" opacity="0.25" />
              <path d="M280 490 Q450 470 620 490 T960 490" stroke="#000000" strokeWidth="0.8" fill="none" opacity="0.2" />

              {/* 螺旋装饰 */}
              <path d="M520 530 Q540 510 560 530 Q580 550 560 570 Q540 590 520 570 Q500 550 520 530" stroke="#000000" strokeWidth="1" fill="none" opacity="0.3" />
              <path d="M540 550 Q550 540 560 550 Q570 560 560 570 Q550 580 540 570 Q530 560 540 550" stroke="#000000" strokeWidth="0.6" fill="none" opacity="0.2" />

              {/* 更多点缀元素 */}
              <circle cx="380" cy="100" r="2.5" fill="#000000" opacity="0.5" />
              <circle cx="460" cy="120" r="2" fill="#000000" opacity="0.4" />
              <circle cx="500" cy="150" r="1.5" fill="#000000" opacity="0.3" />
              <circle cx="480" cy="210" r="2" fill="#000000" opacity="0.4" />
              <circle cx="520" cy="250" r="1.5" fill="#000000" opacity="0.3" />
              <circle cx="450" cy="350" r="2.5" fill="#000000" opacity="0.4" />
              <circle cx="490" cy="410" r="2" fill="#000000" opacity="0.3" />
              <circle cx="420" cy="450" r="1.5" fill="#000000" opacity="0.2" />
              <circle cx="470" cy="510" r="2" fill="#000000" opacity="0.3" />
              <circle cx="510" cy="550" r="1.5" fill="#000000" opacity="0.2" />

              {/* 新增元素 - 几何图形 */}
              <rect x="520" y="430" width="40" height="40" fill="#000000" opacity="0.1" />
              <circle cx="540" cy="450" r="15" fill="#ffffff" opacity="0.08" />

              {/* 新增元素 - 抽象线条 */}
              <path d="M480 480 L520 480 L500 500 Z" fill="#000000" opacity="0.15" />
              <path d="M490 510 Q510 490 530 510" stroke="#000000" strokeWidth="2" fill="none" opacity="0.2" />

              {/* 新增元素 - 点阵装饰 */}
              <circle cx="550" cy="380" r="1" fill="#000000" opacity="0.4" />
              <circle cx="555" cy="385" r="1" fill="#000000" opacity="0.3" />
              <circle cx="560" cy="390" r="1" fill="#000000" opacity="0.4" />
              <circle cx="565" cy="395" r="1" fill="#000000" opacity="0.3" />
              <circle cx="570" cy="400" r="1" fill="#000000" opacity="0.4" />

              {/* 渐变定义 */}
              <defs>
                <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#000000" stopOpacity="0.08" />
                  <stop offset="100%" stopColor="#333333" stopOpacity="0.04" />
                </linearGradient>
                <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#333333" stopOpacity="0.06" />
                  <stop offset="100%" stopColor="#000000" stopOpacity="0.03" />
                </linearGradient>
                <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#000000" stopOpacity="0.05" />
                  <stop offset="100%" stopColor="#333333" stopOpacity="0.02" />
                </linearGradient>
                <linearGradient id="gradient4" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#333333" stopOpacity="0.06" />
                  <stop offset="100%" stopColor="#000000" stopOpacity="0.03" />
                </linearGradient>
                <linearGradient id="gradient5" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#000000" stopOpacity="0.15" />
                  <stop offset="100%" stopColor="#333333" stopOpacity="0.08" />
                </linearGradient>
                <linearGradient id="gradient6" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#ffffff" stopOpacity="0.15" />
                  <stop offset="100%" stopColor="#f0f0f0" stopOpacity="0.08" />
                </linearGradient>
                <linearGradient id="gradient7" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#000000" stopOpacity="0.1" />
                  <stop offset="100%" stopColor="#333333" stopOpacity="0.05" />
                </linearGradient>
                <linearGradient id="gradient8" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#000000" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#333333" stopOpacity="0.1" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
      <div className="copyright-footer">
        © 2025 个人博客. 版权所有.
      </div>
    </div>
  );
};

export default LoginPage;